import React from 'react';
import { Helmet } from "react-helmet";
import themeValue from '../themes/themeValue';

export class MetaTagsHelper {
    static getTags(screenName) {
        switch (screenName) {
            case 'home':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>{themeValue('site.name')} | College Student Housing Finder</title>
                        <meta name="description" content="Use CribWiz as a student housing finder to match with off-campus housing options near your college." />
                        <meta name="keywords" content="college student housing, student housing finder, off-campus housing finder, student housing matcher, find student housing near my college, college apartment finder, college apartment matcher" />
                    </Helmet>
                );
            case 'city-search':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Quick & Easy Apartment Finder | {themeValue('site.name')}</title>
                        <meta name="description" content="Use CribWiz as a apartment finder to match with housing options near your college." />
                        <meta name="keywords" content="apartment housing, apartment finder, fast apartment finder, apartment matcher, find housing near me, easy apartment matcher" />
                    </Helmet>
                );
            case 'college':
                if (typeof meta_title === "undefined"
                    || typeof meta_description === "undefined"
                    || typeof meta_keywords === "undefined") {
                    return;
                }

                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>{meta_title}</title>
                        <meta name="description" content={meta_description} />
                        <meta name="keywords" content={meta_keywords} />
                    </Helmet>
                );
                case 'city':
                if (typeof meta_title === "undefined"
                    || typeof meta_description === "undefined"
                    || typeof meta_keywords === "undefined") {
                    return;
                }

                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>{meta_title}</title>
                        <meta name="description" content={meta_description} />
                        <meta name="keywords" content={meta_keywords} />
                    </Helmet>
                );
            case 'matches':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Your Matches | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'no-matches':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>😭 No matches in your area | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'end-matches-reached':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>😭 You’ve reached the end of your matches | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'questionnaire':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Housing Questionnaire | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'congratulations':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>🎉 Congratulations | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'your-info-move-in':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Your Move-in Details | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'your-info':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Your Information | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'how-to-use':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>How to Use {themeValue('site.name')} | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'edit-your-listing':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Edit Your Listing {themeValue('site.name')} | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'create-your-listing':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Create Your Listing {themeValue('site.name')} | {themeValue('site.name')}</title>
                    </Helmet>
                );
            case 'order-summary':
                this.removeTags();
                return (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Payment Details {themeValue('site.name')} | {themeValue('site.name')}</title>
                    </Helmet>
                );
        }
    }

    static removeTags() {
        if(typeof document === 'undefined') {
            return;
        }

        if (!('remove' in Element.prototype)) {
            Element.prototype['remove'] = function () {
                if (this.parentNode) {
                    this.parentNode.removeChild(this);
                }
            };
        }

        let metaDescription = document.querySelector(`meta[name="description"]`);
        let metaKeywords = document.querySelector(`meta[name="keywords"]`);

        if (metaDescription) {
            metaDescription.remove();
        }

        if (metaKeywords) {
            metaKeywords.remove();
        }
    }
}
